import { render } from "./GroupTravel.vue?vue&type=template&id=f54eebd8"
import script from "./GroupTravel.vue?vue&type=script&lang=js"
export * from "./GroupTravel.vue?vue&type=script&lang=js"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__